import { useState } from "react";
import { Link } from "@tanstack/react-router";

const CONSENT_KEY = "bb-cookie-consent";

function hasStoredConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY) === "1";
  } catch {
    return false;
  }
}

export function CookieConsentBanner() {
  const [dismissed, setDismissed] = useState(hasStoredConsent);

  if (dismissed) return null;

  function accept() {
    try {
      localStorage.setItem(CONSENT_KEY, "1");
    } catch {}
    setDismissed(true);
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t dark:border-white/10 border-black/10 bg-background/95 backdrop-blur-sm px-4 py-3">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-muted-foreground">
          Usamos cookies funcionais e de análise para melhorar sua experiência.{" "}
          <Link
            to="/privacidade"
            className="underline underline-offset-2 transition-colors hover:text-foreground"
          >
            Saiba mais
          </Link>
          .
        </p>
        <button
          onClick={accept}
          className="shrink-0 rounded-md bg-primary px-4 py-1.5 text-xs font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
